/* eslint-disable max-len */
import React from 'react'
import { injectIntl } from 'react-intl'

import { AppContext } from 'src/AppContext'
import { EventSection } from 'src/components/calendar/eventSection'
import { LoadingContent } from 'src/components/loading-content/LoadingContent'
import { LoadingPlaceholder } from 'src/components/loading-content/LoadingPlaceholder'
import { LOCATION_ID } from './constants'

/* eslint-disable css-modules/no-unused-class */
import style from './location.css'
import locale from './locale'

const Placeholder = () => (
  <LoadingPlaceholder modifierClass={style.placeholder}>
    <LoadingContent width="170px" height="25px" borderRadius="rounder" />
    <LoadingContent height="400px" borderRadius="sharper" />
  </LoadingPlaceholder>
)

const LocationComponent = ({ loading, eventData, eventOpen, intl: { formatMessage } }) => {
  if (eventData?.virtual) return null
  const classOverride = eventData?.timedEntry &&
    !eventData.soldOut && eventOpen
    ? 'timedEntry'
    : null

  return (
    <AppContext.Consumer>
      {({ googleMapsLoaded }) => (
        (loading || !googleMapsLoaded) ?
          <Placeholder />
          :
          <EventSection sectionId={LOCATION_ID} heading={formatMessage(locale.location)} classOverride={classOverride}>
            <div className={style.mapContainer}>
              <div className={style.directions}>
                {eventData.venueName && <h4 className={style.heading}>{eventData.venueName}</h4>}
                <p className={style.copy}>{eventData.address}</p>
                <a
                  href={
                    `https://maps.google.com?saddr=Current+Location&daddr=${eventData.latitude},${eventData.longitude}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className={style.link}
                >
                  {formatMessage(locale.getDirections)}
                </a>
              </div>
            </div>
          </EventSection>
      )}
    </AppContext.Consumer>
  )
}

export const Location = injectIntl(LocationComponent)
